import { del, get, post } from "../common/apiClient";

const PATH_CLASS = "/class";

const getMyClasses = async () => {
  return await get(`${PATH_CLASS}/my-classes`);
};

const joinPrivateClass = async (classCode, pin) => {
  return await post(`${PATH_CLASS}/join`, {
    classCode,
    pin,
  });
};

const leaveMyClass = async (classId) => {
  return await del(`${PATH_CLASS}/${classId}/leave`);
};

export { getMyClasses, joinPrivateClass, leaveMyClass };
